import React from "react";
import { Link } from "react-router-dom";
import withRole from "../../../../../Providers/AuthProvider/WithRole";

const ManageCarsLink = () => {
    return <Link to="/manage/cars"> Manage Vehicles </Link>;
};

export default withRole(ManageCarsLink, ["admin", "employee"]);
